module.exports = __webpack_public_path__ + "templates.product_list_variation_selector-8be8955f.html";